var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "wrapper",
    {
      staticClass: "requisition",
      class: _vm.link ? "link" : "",
      attrs: { tag: _vm.link ? "a" : "div", href: _vm.link }
    },
    [
      _c("div", { staticClass: "font-bold mb-1" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.requisition.person_specification.business_line.company.title
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm.requisition.is_pipeline
          ? _c("span", [_c("strong", [_vm._v("[Pipeline]")])])
          : _vm._e(),
        _vm._v(
          " - " + _vm._s(_vm.requisition.person_specification.title) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v("\n        #" + _vm._s(_vm.requisition.id) + "\n    ")
      ]),
      _vm._v(" "),
      _vm.requisition.job_profile
        ? _c("div", [
            _vm._v(
              "\n        Job Profile ID: #" +
                _vm._s(_vm.requisition.job_profile.id) +
                "\n        "
            ),
            _vm.requisition.job_profile.external_requisition_number
              ? _c("div", [
                  _vm._v(
                    "\n            External Requisition Number: " +
                      _vm._s(
                        _vm.requisition.job_profile.external_requisition_number
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.requisition.job_profile.sage_job_requisition
              ? _c("div", [
                  _vm._v(
                    "\n            Sage Job Requisitions: #" +
                      _vm._s(
                        _vm.requisition.job_profile.sage_job_requisition
                          .recruitment_id
                      ) +
                      " - " +
                      _vm._s(
                        _vm.requisition.job_profile.sage_job_requisition
                          .reference_number
                      ) +
                      "\n        "
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("br")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n        Recruiter: " +
            _vm._s(_vm.requisition.creator.full_name) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _vm.requisition.current_status == "first_approval"
        ? _c("div", [
            _vm._v(
              "\n        Approver: " +
                _vm._s(_vm.requisition.first_approver.full_name) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.requisition.current_status == "second_approval"
        ? _c("div", [
            _vm._v(
              "\n        Approver: " +
                _vm._s(_vm.requisition.second_approver.full_name) +
                "\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.requisition.current_status == "third_approval"
        ? _c("div", [
            _vm._v(
              "\n        Approver: " +
                _vm._s(_vm.requisition.third_approver.full_name) +
                "\n    "
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-043d43e2", { render: render, staticRenderFns: staticRenderFns })
  }
}